import React from 'react';
import PropTypes from 'prop-types';
import DatePickerHOC from 'components/widgets/datePickerController';
import momentPropTypes from 'react-moment-proptypes';

const DatePicker = (props) => {
    const {
        date,
        label,
        dateId,
        datePlaceholderText,
        showCalendar,
    } = props;
    return (
        <div>
            <div className="d-flex date-picker-container">
                <button className="date-picker-btn col text-left" type="button" id={dateId} onClick={(e) => { showCalendar(e); }}>
                    <span className="text-label">{label}</span>
                    {(date && date.format('MM/DD/YYYY')) || datePlaceholderText}
                </button>
            </div>
        </div>
    );
};

DatePicker.propTypes = {
    date: momentPropTypes.momentObj,
    datePlaceholderText: PropTypes.string,
    dateId: PropTypes.string.isRequired,
    label: PropTypes.string,
    showCalendar: PropTypes.func.isRequired,
};

DatePicker.defaultProps = {
    date: null,
    label: 'Depart',
    datePlaceholderText: 'Select Date',
};

export default DatePickerHOC(DatePicker);
